export default __webpack_public_path__ + "f6b55ba0fce336952ccd18b9975a39c9.png";